import { Zap, Shield, Globe } from "lucide-react";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  const features = [
    {
      icon: Zap,
      title: "Säker implementering",
      description: "Effektiva agila AI processer för kvalitativa lösningar."
    },
    {
      icon: Shield,
      title: "Pålitlig långsiktig partner",
      description: "Vi värdesätter långsiktiga relationer byggda på förtroende."
    },
    {
      icon: Globe,
      title: "Skandinavisk förankring",
      description: "Lokal expertis med globala arbetslivserfarenheter."
    }
  ];

  return (
    <section
      id="why-choose-us"
      className="py-8 md:py-20 bg-primary relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16 md:py-8 md:px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-foreground mb-4">
            Varför välja oss?
          </h2>
          <div className="text-lg text-primary-foreground/80 max-w-3xl mx-auto">
            <p className="mb-2">15+ års erfarenhet inom IT och digitalisering</p>
            <div className="flex items-center justify-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-primary-foreground/40" />
            </div>
            <p className="mt-2">Snabba och kostnadseffektiva lösningar för er verksamhet</p>
            <p className="mt-4">
              <Link to="/about#team" className="text-accent hover:underline font-medium">
                Möt vårt team →
              </Link>
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="bg-primary-foreground/10 border border-primary-foreground/20 p-6 md:p-8 rounded-lg shadow-card text-center hover:shadow-hero transition-all duration-300"
              >
                <div className="flex justify-center mb-4 md:mb-6">
                  <IconComponent className="w-12 h-12 md:w-16 md:h-16 text-accent" />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-primary-foreground mb-2 md:mb-4">
                  {feature.title}
                </h3>
                <p className="text-sm md:text-base text-primary-foreground/80 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
